import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Injectable({
  providedIn: 'root',
})
/**
 * Guard that activates only if there is not an authenticated user
 */
export class UnauthenticatedGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(
    private readonly router: Router,
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * @return {boolean}
   */
  canActivate(): boolean {
    if (this.authenticatedUserService.user !== undefined) {
      this.router.navigate([RoutesKeys.HOME]);
      return false;
    }
    return true;
  }
}
